import { render, staticRenderFns } from "./perform-inspection-form.vue?vue&type=template&id=bfbc9074&scoped=true"
import script from "./perform-inspection-form.vue?vue&type=script&lang=js"
export * from "./perform-inspection-form.vue?vue&type=script&lang=js"
import style0 from "./perform-inspection-form.vue?vue&type=style&index=0&id=bfbc9074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc9074",
  null
  
)

export default component.exports